define([
    'dojo/dom-class',
    'dojo/on',
    'dojo/_base/declare',
    'dijit/_WidgetBase',
    'dijit/_TemplatedMixin',
    'dojo/text!./templates/ColorStyle.html',
    'dojo/i18n!./l10n/nls/ColorPickerResources'
], function (domClass, on, declare, _WidgetBase, _TemplatedMixin, template, l10nStrs) {
    return declare([_WidgetBase, _TemplatedMixin], {

        /**
         * @event previewchange
         * @description Event fired on mouse over of a color style
         * @type {object}
         * @property {string} value - ColorStyle value when event was fired.
         */

        /**
         * @property {string} value - Hex value of the current color value
         * @instance
         */
        value: null,

        selected: false,

        baseClass: 'mwColorStyle',

        templateString: template,

        postCreate: function () {
            this.inherited(arguments);
            this.own(on(this.colorStyleButton, 'focus', this._select.bind(this)));
            this.own(
                on(this.colorStyleSwatch, 'mouseenter, mouseleave', this._handleHover.bind(this))
            );

            /* For ie11 bug in which clicking on a child element that is focusable does not focus the parent */
            this.own(on(this.colorStyleSwatch, 'click', this._focusColorStyleNode.bind(this)));
            this.own(on(this.colorStyleLabel, 'click', this._focusColorStyleNode.bind(this)));
        },

        _focusColorStyleNode: function () {
            this.colorStyleButton.focus();
        },

        _setSelectedAttr: function (newVal) {
            this._set('selected', newVal);
            if (newVal) {
                domClass.add(this.colorStyleButton, 'mwColorStyleSelected');
            } else {
                domClass.remove(this.colorStyleButton, 'mwColorStyleSelected');
            }
        },

        _select: function () {
            this.set('selected', true);
            this.emit('change', {
                value: this.value
            });
        },

        _handleHover: function (e) {
            this.emit('previewchange', {
                value: this.value,
                eventData: e
            });
        },

        _setValueAttr: function (newVal) {
            this._set('value', newVal);
            var newValKey = newVal.charAt(0).toUpperCase() + newVal.slice(1);
            domClass.add(this.colorStyleButton, 'mwColorStyle' + newValKey);
            this.colorStyleLabel.textContent = l10nStrs[newVal];
        }
    });
});
